import { useMutation } from '@tanstack/react-query';
import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';
import { MutationOptions } from 'types/utils/mutation-options';

export type TestMessageResponseType = {
  access_token: string;
  refresh_token: string;
};

export type TestMessagePayload = {
  campaign_id?: string;
  message?: string;
};

type Params = {
  message: TestMessagePayload;
  test_user_ids: number[];
  channel: 'sms' | 'push';
};

export const useSendTestMessage = (
  options: MutationOptions<TestMessageResponseType, Params>
) =>
  useMutation({
    mutationFn: async (params: Params) => {
      const { data } = await api.post<ApiResponse<TestMessageResponseType>>(
        `/campaign/send-test-message?channel=${params.channel}`,
        {
          message: params.message,
          test_user_ids: params.test_user_ids,
        }
      );

      return data.data;
    },

    ...options,
  });
